<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataTempKey="refHazTemp"
                    userAuthorizeRole="HAZ"
                    :isLoading="isLoading"
                    approveCodeKey="approveCode2"
                    approveCodeKey2="approveCode"
                    :approveCodeKey2Label="$t('model.haz.approveCode')"
                ></RequestorForm>
            </TabPane>
            <TabPane key="HazInfo" :tab="$t('views.request.hazInfo.title')" :forceRender="true">
                <HazInfoForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></HazInfoForm>
            </TabPane>
            <TabPane key="HazPictogram" :tab="$t('views.request.hazPictogram.title')" :forceRender="true">
                <HazPictogramForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                    v-if="data.pictograms"
                ></HazPictogramForm>
            </TabPane>
            <TabPane key="HazPackage" :tab="$t('views.request.hazPackage.title')" :forceRender="true">
                <HazPackageForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></HazPackageForm>
            </TabPane>
            <TabPane key="HazTest" :tab="$t('views.request.hazTest.title')" :forceRender="true">
                <HazTestForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></HazTestForm>
            </TabPane>
            <TabPane key="HazUseRate" :tab="$t('views.request.hazUseRate.title')" :forceRender="true">
                <HazUseRateForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></HazUseRateForm>
            </TabPane>
            <TabPane key="HazDistributor" :tab="$t('views.request.hazDistributor.title')" :forceRender="true">
                <HazDistributorForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></HazDistributorForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHazTemp"
                    :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../app.logic";
import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
        HazInfoForm: defineAsyncComponent(() => import("./haz-info/HazInfoForm")),
        HazPictogramForm: defineAsyncComponent(() => import("./haz-pictogram/HazPictogramForm")),
        HazPackageForm: defineAsyncComponent(() => import("./haz-package/HazPackageForm")),
        HazTestForm: defineAsyncComponent(() => import("./haz-test/HazTestForm")),
        HazUseRateForm: defineAsyncComponent(() => import("./haz-use-rate/HazUseRateForm")),
        HazDistributorForm: defineAsyncComponent(() => import("./haz-distributor/HazDistributorForm")),
        AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
        RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "haz-requests" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false }
    },
    setup(props) {
        // eslint-disable-next-line vue/no-mutating-props
        //props.menuContext.tabKey = "HazDistributor";
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
